import { Card, CardBody } from '@heroui/react';
import React from 'react';

type AlertType = 'error' | 'warning' | 'info' | 'success';

interface AlertCardProps {
  type?: AlertType;
  title?: string;
  message: string;
  className?: string;
}

const getAlertStyles = (type: AlertType) => {
  switch (type) {
    case 'error':
      return {
        cardClass: 'border-danger-200 bg-danger-50',
        iconBg: 'bg-danger-500',
        titleClass: 'text-danger-800',
        messageClass: 'text-danger-700',
        icon: '!',
      };
    case 'warning':
      return {
        cardClass: 'border-warning-200 bg-warning-50',
        iconBg: 'bg-warning-500',
        titleClass: 'text-warning-800',
        messageClass: 'text-warning-700',
        icon: '⚠',
      };
    case 'info':
      return {
        cardClass: 'border-primary-200 bg-primary-50',
        iconBg: 'bg-primary-500',
        titleClass: 'text-primary-800',
        messageClass: 'text-primary-700',
        icon: 'i',
      };
    case 'success':
      return {
        cardClass: 'border-success-200 bg-success-50',
        iconBg: 'bg-success-500',
        titleClass: 'text-success-800',
        messageClass: 'text-success-700',
        icon: '✓',
      };
    default:
      return getAlertStyles('error');
  }
};

export const AlertCard: React.FC<AlertCardProps> = ({
  type = 'error',
  title,
  message,
  className = '',
}) => {
  const styles = getAlertStyles(type);

  return (
    <Card className={`${styles.cardClass} ${className}`}>
      <CardBody>
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0">
            <div
              className={`w-5 h-5 ${styles.iconBg} rounded-full flex items-center justify-center`}
            >
              <span className="text-white text-xs font-bold">
                {styles.icon}
              </span>
            </div>
          </div>
          <div>
            {title && (
              <p className={`text-sm font-medium ${styles.titleClass} mb-1`}>
                {title}
              </p>
            )}
            <p className={`text-sm ${styles.messageClass}`}>{message}</p>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
